
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.982 8.2L10.684 18H9.298L4.986 8.2h1.512l3.528 8.05 3.556-8.05h1.4zm1.25 0h1.4V18h-1.4V8.2zm8.156 0c1.269 0 2.268.303 2.996.91.728.607 1.092 1.442 1.092 2.506 0 1.064-.364 1.9-1.092 2.506-.728.607-1.727.91-2.996.91h-2.422V18h-1.4V8.2h3.822zm-.042 5.614c.886 0 1.563-.187 2.03-.56.466-.383.7-.929.7-1.638 0-.71-.234-1.25-.7-1.624-.467-.383-1.144-.574-2.03-.574h-2.38v4.396h2.38z","fill":"#EB5757"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"33","height":"24","rx":"1.5","stroke":"#EB5757"}})])
          )
        }
      }
    